<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2> Rejestracja</h2>
  </div>

  <div fxFlex="100" >

    <app-dict-registrations fxFlex="100" label="Rejestracja" [control]="registrationControl" [status]="true"  [company]="true" [required]="false" [filterInsuranceCompany]="insuranceCompany"  [filterStatus]="[REGISTRATION_STATUS_REGISTERED]" ></app-dict-registrations>

  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest "
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
